import React from 'react';
import RecentPostsWidgetRoot from '../../../recent-posts-widget/components/recent-posts-widget-root';
import { withLayoutUpdate } from '../../../common/hoc/with-layout-update';
import { withInvalidAppState } from '../../../common/hoc/with-invalid-app-state';
import InvalidAppStatePage from '../../../app/components/invalid-app-state-page';
import { withErrorState } from '../../../common/hoc/with-error-state';

const DeprecatedEmptyState = () => (
  <div style={{
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    width: '100%', minHeight: '200px',
    fontFamily: 'Madefor, HelveticaNeue, Helvetica, Arial, sans-serif',
    padding: '40px 20px', boxSizing: 'border-box' as const,
    backgroundColor: '#fff',
  }}>
    <div style={{ textAlign: 'center', maxWidth: '500px' }}>
      <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '12px' }}>
        Wix Forum is no longer available
      </h2>
      <p style={{ color: '#666', fontSize: '16px', lineHeight: '1.5' }}>
        This application has been discontinued. If you need community app use Wix Groups.
      </p>
    </div>
  </div>
);

const OriginalWidget = withErrorState(
  withLayoutUpdate(withInvalidAppState(RecentPostsWidgetRoot, InvalidAppStatePage)),
  InvalidAppStatePage,
);

export default (props: any) => {
  if (props.isDeprecated) {
    return <DeprecatedEmptyState />;
  }
  return <OriginalWidget {...props} />;
};
